module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "left "
  }, [_vm._v("First Mariner Books edition 2017")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Copyright © 2016 by Peter Ho Davies")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Reading Group Guide copyright © 2017 by Houghton Mifflin Harcourt Publishing Company")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Q&A with Author copyright © 2017 by Peter Ho Davies")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('a', {
    attrs: {
      "href": "http://www.hmhco.com/Popular-reading",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Names: Davies, Peter Ho, date, author.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Title: The fortunes / Peter Ho Davies.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Description: Boston ; New York : Houghton Mifflin Harcourt, 2016.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Identifiers: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCCN")]), _vm._v(" 2016005161 (print) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCCN")]), _vm._v(" 2016011840 (ebook) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9780544263703 (hardback) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9780544263789 (ebook) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9781328745484 (pbk)")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Subjects: | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BISAC: FICTION")]), _vm._v(" / Literary. | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FICTION")]), _vm._v(" / General.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Classification: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCC")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PR")]), _vm._v("6054."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v("89145 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v("45 2016 (print) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCC")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PR")]), _vm._v("6054."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v("89145 (ebook) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DDC")]), _vm._v(" 823/.914—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LC")]), _vm._v(" record available at "), _c('a', {
    attrs: {
      "href": "http://lccn.loc.gov/2016005161",
      "target": "_blank"
    }
  }, [_vm._v("http://lccn.loc.gov/2016005161")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Cover design by Brian Moore")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Hand lettering by Joel Holland")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("v3.1120")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("“Kung Fu Fighting,” written by Carlton Douglas, © Edition Carren. All rights reserved. Used by permission.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("“Half-Caste Woman,” words and music by Noël Coward, copyright © 1931 (renewed) WB Music Corp. All rights reserved. Used by permission of Alfred Music.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("“These Foolish Things,” words by Holt Marvell, music by Jack Strachey. Copyright © 1936 (renewed) by Boosey & Co. Ltd. All rights for the U.S.A. and Canada controlled by Bourne Co. All rights reserved. International copyright secured. ASCAP.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Oriental riff illustration on "), _c('a', {
    attrs: {
      "href": "#/front03#px3"
    }
  }, [_vm._v("page vii")]), _vm._v(": © 2016 Houghton Mifflin Harcourt Publishing Company.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0223e7e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 63
// module chunks = 0